module.exports = __webpack_public_path__ + "img/mobile scanner stand25.1d3c76c6.jpg";